<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="feedingForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                feedingForm: () => import('../forms/FeedingForm'),
                headers: [
                    { text: 'Load', value: 'loadId', table: 'loads', form: () => import('../forms/LoadForm') },
                    { text: 'Feed Purchase', value: 'feedPurchaseId', table: 'feedPurchases', form: () => import('../forms/FeedPurchaseForm') },
                    { text: 'Applied On', value: 'appliedOn', format: this.formatDate },
                    { text: 'Amount In Millilitres', value: 'amountInMillilitres' },
                    { text: 'Amount In Grams', value: 'amountInGrams' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    feedPurchases: [],
                    loads: [],
                    items: []
                },
                sorting: [
                    { column: "appliedOn", direction: "descending" },
                    { column: "loadId", direction: "ascending" },
                    { column: "feedPurchaseId", direction: "ascending" },
                ],
                itemsField: 'feedings',
                editPageName: 'feeding',
                apiMethod: 'Feedings',
                claimName: 'Feedings',
                formTitle: 'Feeding',
                excelTitle: 'Feedings',
                hasEditPage: false,
            }
        },
    };
</script>
